export const EDIT_INSIGHTS_INPUT_LIMIT: number = 3000;

export const WIDGET_ID = "widget-insights";
